import { getJournalEntryRevisionsAsync } from '../../../API/accounting/getJournalEntryRevisionsAsync';
import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { createDefaultPageData } from 'types/rest/IPageData';

export const { slice: journalEntryLogsSlice, asyncAction: loadJournalEntryRevisionsAction } =
  createAsyncSliceWithDataAndQuery('journalEntryLogsSlice', getJournalEntryRevisionsAsync, createDefaultPageData());
